import { VueSlideToggle } from "vue-slide-toggle";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "static-content",
  props: {
    isNews: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openAside: true,
      openCategories: false
    }
  },
  async created() {
    await this.getFreshNews();
  },
  methods: {
    ...mapActions({
      getFreshNews: "pages/GET_FRESH_NEWS",
    }),
    toggleAside() {
      this.openAside = !this.openAside;
    }
  },
  components: {
    VueSlideToggle
  },
  computed: {
    ...mapGetters({
      freshNews: "pages/freshNews",
      headerMenu: "setting/headerMenu",
    }),
    categories() {
      if (!this.headerMenu) return [];
      return this.headerMenu.find(item => item.slug === 'innovations')?.items || [];
    },
    additionalClasses() {
      if (this.$route && this.$route.query && this.$route.query.type) {
        return this.$route.query.type;
      }
      return "";
    },
  },
};
